import { __assign } from 'tslib';
import { useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';
import isBefore from '../../node_modules/date-fns/esm/isBefore/index.js';
import isSameYear from '../../node_modules/date-fns/esm/isSameYear/index.js';
import isAfter from '../../node_modules/date-fns/esm/isAfter/index.js';
import getYear from '../../node_modules/date-fns/esm/getYear/index.js';
import addYears from '../../node_modules/date-fns/esm/addYears/index.js';
import subYears from '../../node_modules/date-fns/esm/subYears/index.js';

var getYearProps = function (_a) {
    var date = _a.date, _b = _a.focusDate, focusDate = _b === void 0 ? new Date() : _b, value = _a.value, disabledBefore = _a.disabledBefore, disabledAfter = _a.disabledAfter, disabled = _a.disabled, readonly = _a.readonly, mode = _a.mode;
    return __assign(__assign(__assign(__assign(__assign({ disabled: disabled, readonly: readonly }, (disabledBefore &&
        isBefore(date, disabledBefore) &&
        !isSameYear(date, disabledBefore) && {
        disabled: true,
    })), (disabledAfter &&
        isAfter(date, disabledAfter) &&
        !isSameYear(date, disabledAfter) && {
        disabled: true,
    })), (mode === "year" &&
        isSameYear(date, focusDate) && { isFocus: true, tabIndex: 0 })), (value &&
        !Array.isArray(value) &&
        isSameYear(date, value) && { selected: true })), (value &&
        Array.isArray(value) &&
        value.filter(function (d) { return isSameYear(date, d); }).length > 0 && {
        selected: true,
    }));
};
var useDateKeyDownHandler = function (_a) {
    var navigateDate = _a.navigateDate, disableToggleMode = _a.disableToggleMode, setMode = _a.setMode, date = _a.date;
    return function (e) {
        switch (e.code) {
            case "ArrowLeft":
                e.preventDefault();
                navigateDate(subYears(date, 1));
                break;
            case "ArrowRight":
                e.preventDefault();
                navigateDate(addYears(date, 1));
                break;
            case "ArrowUp":
                e.preventDefault();
                navigateDate(subYears(date, 4));
                break;
            case "ArrowDown":
                e.preventDefault();
                navigateDate(addYears(date, 4));
                break;
            case "Enter":
            case "Space":
                e.preventDefault();
                navigateDate(date);
                !disableToggleMode && setMode("month");
                break;
        }
    };
};
var useDatePickerYear = function (_a) {
    var date = _a.date;
    var context = useDatePickerContext();
    var renderYear = context.renderYear, setMode = context.setMode, navigateDate = context.navigateDate, selectDate = context.selectDate, yearsRef = context.yearsRef, size = context.size, disableToggleMode = context.disableToggleMode, selectOnNavigate = context.selectOnNavigate;
    var yearProps = getYearProps(__assign({ date: date }, context));
    var y = getYear(date);
    var dateKeyDownHandler = useDateKeyDownHandler({
        navigateDate: navigateDate,
        disableToggleMode: disableToggleMode,
        setMode: setMode,
        date: date,
    });
    var dateClickHandler = function (e) {
        e.preventDefault();
        selectOnNavigate ? selectDate(date) : navigateDate(date);
        !disableToggleMode && setMode("month");
    };
    return {
        props: __assign(__assign({}, yearProps), { size: size, ref: function (element) {
                return element && (yearsRef.current[y] = element);
            }, onKeyDown: dateKeyDownHandler, onClick: dateClickHandler, children: renderYear ? renderYear({ date: date }) : y }),
    };
};

export { useDatePickerYear };
//# sourceMappingURL=useDatePickerYear.js.map
